module.exports = __webpack_public_path__ + "img/photoshop.571c32c6.svg";